export const DEFAULT_LOCALE = 'en';
export const LOCALES = ['en'];
